const traduction = {
  common: {
    next: "Next",
    cancel: "Cancel",
  },
  forgetPassword: {
    title: "اعد ضبط كلمه السر",
    EmailPlaceholder: "* عنوان برديك الالكتروني",
    buttonRest:'إعادة تعيين كلمة المرور',
    buutonBack:'العودة إلى تسجيل الدخول',
    successMessage:'!إعادة تعيين كلمة المرور',
    sigin:'تسجيل الدخول'
  },
  activation:{
    title:'فعل حسابك',
    go:'الذهاب إلى لوحة القيادة',
    back:'العودة لتسجيل الدخول',
    confirm:'اكد هويتك',
    successMessage:'! تم تفعيل حسابك'
  },
  logOut: {
    logIn: "Sign in to",
    register: "Register",
  },
  logIn: {
    title: "Join TAWA community now.",
    logIn: "قم بتسجيل الدخول إلى",
    EmailPlaceholder: "* عنوان برديك الالكتروني",
    PasswordPlaceholder: "*كلمة المرور",
    ForgetPassword: "نسيت كلمة المرور؟",
    "Sign-in": " تسجيل الدخول",
    "have-not-account": "ليس لديك حساب ؟",
    "create-account": "إنشاء حساب مجاني",
    
      emailRequired: "البريد الالكتروني مطلوب",
      emailValidation: "البريد الإلكتروني غير صالح",
      passwordRequired: "كلمة المرور مطلوبة",
      passwordValidation: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
      agencyName: "اسم الوكالة مطلوب",
      socialMedia: "أدخل اسم مستخدم واحد على الأقل لوسائل التواصل الاجتماعي",
    
  },
  SignUp: {
    title: "سجل مجانا",
    button: {
      creator: "صانع المحتوى",
      advertiser: "المستشهر",
      SignUp: "سجل مجانا",
      SignIn: "تسجيل الدخول",
    },
    radioButton: {
      title: ": أنت",
      brand: "العلامة التجارية",
      agency: "الوكالة",
    },
    FormInput: {
      placeholder: {
        name: "*الوكالة/العلامة التجارية",
        instgram: "إنستغرام",
        tiktok: "تيك توك",
        email: "* عنوان البريد الالكتروني",
        password: "*كلمة المرور",
        confirmPassword: "*تأكيد كلمة المرور",
      },
    },
    "have-not-account": "هل لديك حساب؟ "   ,
    "agree-message-simple": "أوافق على",
    "agree-message-bold": ".اتفاقية المستخدم وسياسة الخصوصية"    ,
    
      emailRequired: "إدخال البريد الإلكتروني مطلوب "     ,
      emailValidation: "البريد الإلكتروني غير صالح",
      agencyName: "اسم الوكالة مطلوب",
      passwordRequired: "كلمة المرور مطلوبة",
      passwordValidation1: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
      passwordValidation2: "يجب أن تكون كلمة المرور 24 حرفاً على الأكثر",
      passwordValidation3:"يجب أن تحتوي كلمة المرور على حرف واحد كبير على الأقل",
      passwordValidation4: "لا يمكن أن تحتوي كلمة المرور على مسافات",
      passwordValidation5:"كرر كلمة المرور من أجل تأكيدها",
      passwordValidation6:"يجب أن تتطابق كلمات المرور",
      passwordValidation7:"كلمات المرور المؤكدة",
      passwordStrong: "كلمة المرور قوية",
      phoneValidation1:"فقط-أرقام",
      phoneValidation2:"يجب أن يحتوي الهاتف على أرقام فقط",
      socialMedia: "أدخل اسم مستخدم واحد على الأقل لوسائل التواصل الاجتماعي",
      activationEmail : "يرجى التحقق من بريدك الإلكتروني للتحقق من صحة",
      activationAccount : ".حسابك",
      termsRequired:"يجب أن تقبل الشروط"  

  },
};
export default traduction;
